// src/components/news/About_news.js

import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../config/fireabseConfig"; // Ensure the Firebase config path is correct
import HeadLine from "../headLine";
import Image from "next/image";
import News_item from "./news_item";

const About_news = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true); // Initialize loading state

  useEffect(() => {
    // Fetch blog posts from Firebase
    const fetchBlogPosts = async () => {
      try {
        const blogCollection = collection(db, "blogPosts");
        const snapshot = await getDocs(blogCollection);
        const posts = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setBlogPosts(posts.slice(0, 3)); // Fetch the first 3 blog posts
      } catch (error) {
        console.error("Error fetching blog posts:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchBlogPosts();
  }, []);

  return (
    <>
      {/* <!-- Latest Posts --> */}
      <section className="relative py-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <Image
            src="/images/gradient_light.jpg"
            layout="fill"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <div className="container">
          <HeadLine
            text="Articles that might interest you"
            classes="font-display text-jacarta-700 mb-12 text-center text-3xl dark:text-white"
          />

          {loading ? (
            // Loading Skeleton
            <div className="grid grid-cols-1 gap-[1.875rem] sm:grid-cols-2 md:grid-cols-3">
              {[...Array(3)].map((_, index) => (
                <div
                  key={index}
                  className="rounded-2xl overflow-hidden bg-gray-200 animate-pulse"
                >
                  <div className="h-48 bg-gray-300"></div>
                  <div className="p-4">
                    <div className="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
                    <div className="h-4 bg-gray-300 rounded w-full mb-4"></div>
                    <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            // Render News Items
            <News_item data={blogPosts.slice(0, 3)} />
          )}
        </div>
      </section>
      {/* <!-- end latest posts --> */}
    </>
  );
};

export default About_news;
